"use client";
import React from "react";

import { ModernaBrand } from "./colors";
import { ThemeBrandColors, ThemeMode } from "./types";

export const ThemeContext = React.createContext<{
  initialized: boolean;
  mode: ThemeMode;
  brand: ThemeBrandColors;
}>({
  initialized: false,
  mode: "light",
  brand: ModernaBrand
});
